import {
  Col,
  Row,
  Space,
  Table,
  Card,
  Spin,
  Select,
  message,
  Button,
  Tag,
  Input,
  Drawer,
  Checkbox,
  Grid,
  Tooltip,
  Flex,
  Radio,
} from "antd";
import React, { useState, useMemo } from "react";
import MotionHoc from "../../../utils/MotionHoc";
import {
  SearchOutlined,
  PlusOutlined,
  FilterOutlined,
  SendOutlined,
  ReloadOutlined,
  DownSquareOutlined,
  UpSquareOutlined,
  CloseCircleOutlined,
  CheckCircleTwoTone,
} from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";
import {
  BASE_URL_BEN,
  HEADERS_EXPORT_BEN,
  POST_CANCEL_HAND_PRE,
  POST_PRE_INVESTIGATE,
  POST_PRE_INVESTIGATE_CANCEL_HAND,
  POST_LOAN_DB2,
  POST_PRE_INVESTIGATE_CHECK,
  POST_LOAD_RESUE_JUDGE,
  POST_CONTNO_DETAIL_SEARCH,
  HEADERS_EXPORT_DETAIL,
} from "../../API/apiUrls";
import CurrencyFormat from "../../../hook/CurrencyFormat";

import {
  BASE_OPTIONS,
  EXCLUSIONS,
  OPTION_CONTRACT_PERIOD,
  OPTION_CONTRACT_PERIOD_KSM,
  OPTIONS_STATUS,
  OPTIONS_TIME,
  OPTIONS_TYPE,
  OPTIONS_TYPE_KSM,
  STATUS_PROCESS,
} from "./constant/SelectOption";
import SendToLawyers from "./modal/SendToLawyers";
import { optionsLocat } from "../../../utils/constant/LocatOption";
import SendToLawyersResue from "./modal/SendToLawyersResue";

// ============================================
// 🎯 MAIN COMPONENT
// ============================================
const Main = () => {
  // ==================== HOOKS ====================
  const [
    currencyFormat,
    currencyFormatComma,
    currencyFormatPoint,
    currencyFormatNoPoint,
  ] = CurrencyFormat();

  const screens = Grid.useBreakpoint();
  const isMobile = !screens.md;

  // ==================== STATE MANAGEMENT ====================
  const userCompany = localStorage.getItem("COMPANY_ID");
  const roleId = localStorage.getItem("ROLE_ID");
  const userId = parseInt(localStorage.getItem("USER_ID"));
  // Data states
  const [loading, setLoading] = useState(false);
  const [arrData, setArrData] = useState([]); // Raw data from API
  const [arrayTable, setArrayTable] = useState([]); // Filtered data for display
  const [tableMode, setTableMode] = useState("normal"); // normal | resue | defict (ตามผลค้นหาล่าสุด)

  // Selection states
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  // Filter states
  const [typeSelect, setTypeSelect] = useState(); // ระยะเวลาขาดการติดต่อ (270/180/120 วัน)
  const [dataType, setDataType] = useState(); // ประเภทสัญญา
  const [selectRangeTime, setSelectRangeTime] = useState(); // ช่วงเวลาเพิ่มเติม
  const [selectProgressData, setSelectProgessData] = useState([]); // สถานะข้อมูล
  const [searchInput, setSearchInput] = useState(null); // ค้นหาเลขสัญญา
  const [advanceSearch, setAdvanceSearch] = useState(false);
  const [searchContno, setSearchContno] = useState(null);
  const toggle = () => setAdvanceSearch((v) => !v);
  const [searchType, setSearchType] = useState(
    userId === 12 ? "time" : "contno",
  );

  // Modal states
  const [isModal, setIsModal] = useState(false);
  const [dataRecord, setDataRecord] = useState();
  const [statusModal, setStatusModal] = useState(null);
  const [isModalResue, setIsModalResue] = useState(false);
  // UI states
  const [arrow, setArrow] = useState("Show");
  const [openFilter, setOpenFilter] = useState(false); // Drawer ฟิลเตอร์หลัก (mobile)
  const [openFilter2, setOpenFilter2] = useState(false); // Drawer ฟิลเตอร์เสริม (mobile)

  console.log("userCompany", userCompany);

  // ==================== COMPUTED VALUES ====================
  /**
   * 🎯 สร้าง options สำหรับเลือกสถานะ พร้อม disable ตาม logic:
   * - ถ้าเลือก "ทั้งหมด" (0) จะ disable ตัวอื่น
   * - ถ้าเลือกตัวอื่นแล้ว จะ disable "ทั้งหมด"
   * - ใช้ EXCLUSIONS เพื่อ disable option ที่ขัดแย้งกัน
   */
  const optionsForLawsuit = useMemo(() => {
    return BASE_OPTIONS.map((opt) => {
      let disabled = false;

      // กรณีเลือก "ทั้งหมด" (value = 0)
      if (selectProgressData.includes(0) && opt.value !== 0) {
        disabled = true;
      }

      // กรณีเลือกตัวอื่นแล้ว ให้ disable "ทั้งหมด"
      if (
        opt.value === 0 &&
        selectProgressData.length > 0 &&
        !selectProgressData.includes(0)
      ) {
        disabled = true;
      }

      // เช็คว่ามี option ที่ขัดแย้งกันไหม
      selectProgressData.forEach((sel) => {
        const conflictList = EXCLUSIONS[sel];
        if (Array.isArray(conflictList) && conflictList.includes(opt.value)) {
          disabled = true;
        }
      });

      return { ...opt, disabled };
    });
  }, [selectProgressData]);

  // ==================== UTILITY FUNCTIONS ====================
  /**
   * 🔄 Clear selection state
   */
  const clearSelectedRows = () => {
    setSelectedRowKeys([]);
    setSelectedRows([]);
  };

  const mergedArrow = useMemo(() => {
    if (arrow === "Hide") {
      return false;
    }
    if (arrow === "Show") {
      return true;
    }
    return {
      pointAtCenter: true,
    };
  }, [arrow]);

  /**
   * 🔍 Normalize string สำหรับการค้นหา
   */
  const normalizeString = (value) => {
    return String(value ?? "")
      .trim()
      .toLowerCase();
  };

  /**
   * 📅 คำนวณจำนวนวันที่ผ่านมาจากวันที่ระบุ
   */
  const calculateDaysFromNow = (dateString) => {
    if (!dateString || !dayjs(dateString).isValid()) return null;
    return dayjs().startOf("day").diff(dayjs(dateString).startOf("day"), "day");
  };

  // ==================== DATA HANDLERS ====================
  /**
   * 🔍 Query ข้อมูลหลัก - เริ่มต้นการค้นหาข้อมูล
   * ตรวจสอบว่าเลือกตัวกรองครบหรือไม่ ก่อนเรียก loadData
   */
  const onQueryData = () => {
    clearSelectedRows();
    setSelectRangeTime(null);
    console.log("typeSelect", typeSelect);
    console.log("searchInput", searchInput);
    console.log("searchContno", searchContno);

    if ((typeSelect || searchContno) && dataType) {
      loadData();
    } else if (
      searchType === "resue" ||
      searchType === "defict" ||
      searchContno
    ) {
      loadData();
    } else {
      message.error("กรุณาเลือกข้อมูลให้ครบ");
    }
  };

  /**
   * 📊 กรองข้อมูลตาม filter ที่เลือก
   * รองรับการกรอง 4 แบบ:
   * 1. ค้นหาด้วยเลขสัญญา
   * 2. กรองตามระยะเวลา
   * 3. กรองตามสถานะ (multiple)
   * 4. กรณีพิเศษ (combination ของหลายสถานะ)
   */
  const handlefilterData = (data) => {
    setLoading(true);
    clearSelectedRows();

    const dataFilter = data || arrData;
    const rows = Array.isArray(dataFilter) ? dataFilter : [];
    const sel = Array.isArray(selectProgressData) ? selectProgressData : [];
    const daysSel = Number.isFinite(+selectRangeTime) ? +selectRangeTime : null;

    const query = normalizeString(searchInput);

    let dataSelect = [...rows];

    // ✅ 1) กรองด้วยคำค้นหาเลขสัญญา
    if (query) {
      dataSelect = dataSelect.filter((item) =>
        normalizeString(item?.CONTNO).includes(query),
      );
    }

    // ✅ 2) กรองตามระยะเวลาที่เลือก
    if (daysSel > 1) {
      dataSelect = dataSelect.filter((item) => {
        const diff = calculateDaysFromNow(item?.dateCancelContno);
        return diff != null && diff > daysSel;
      });
    }

    // ✅ 3) กรองตามสถานะที่เลือก (ใช้ map เพื่อลด if-else)
    const statusFilters = {
      1: (it) =>
        (it?.statusActiveInvestigate === 3 ||
          it?.statusActiveInvestigate === 4) &&
        !!it?.dateOnlineInvestigate &&
        it?.statusActiveCancelContno === true,
      2: (it) => it?.statusActiveInvestigate === 3,
      3: (it) => it?.statusActiveInvestigate === 4,
      4: (it) => it?.statusActiveCancelContno !== null,
      5: (it) => it?.statusActiveCancelContno === null,
      6: (it) => it?.statusActiveInvestigate === null,
      7: (it) => it?.statusActiveInvestigate === 2,
      8: (it) => (it?.countCancelContno ?? 0) > 0,
      9: (it) => it?.statusActiveCancelContno === true,
      10: (it) => it?.statusActiveInvestigate === 1,
    };

    const keys = sel.map((s) => (typeof s === "object" ? s.value : s));
    const hasAll = keys.includes(0); // ถ้าเลือก "ทั้งหมด"

    if (sel.length > 0 && !hasAll) {
      dataSelect = dataSelect.filter((it) =>
        keys.some(
          (k) => typeof statusFilters[k] === "function" && statusFilters[k](it),
        ),
      );
    }

    // ✅ 4) กรณีพิเศษ (เลือกหลายสถานะพร้อมกัน)
    const specialCases = [
      {
        cond: sel.includes(2) && sel.includes(3),
        filter: (it) =>
          it?.statusActiveInvestigate === 3 ||
          it?.statusActiveInvestigate === 4,
      },
      {
        cond: sel.includes(3) && sel.includes(6),
        filter: (it) =>
          it?.statusActiveInvestigate === 4 || !it?.statusActiveInvestigate,
      },
      {
        cond: sel.includes(3) && sel.includes(7),
        filter: (it) => [1, 2, 4].includes(it?.statusActiveInvestigate),
      },
      {
        cond: sel.includes(4) && sel.includes(9),
        filter: (it) => (it?.statusActiveCancelContno ?? -1) >= 0,
      },
      {
        cond: sel.includes(4) && sel.includes(8),
        filter: (it) =>
          (it?.statusActiveCancelContno ?? -1) >= 0 ||
          (it?.maxCancelContno ?? 0) > (it?.countCancelContno ?? 0),
      },
      {
        cond: sel.includes(1) && sel.includes(2) && sel.includes(3),
        filter: (it) =>
          [3, 4].includes(it?.statusActiveInvestigate) &&
          it?.statusActiveCancelContno === true,
      },
    ];

    // Apply special case filters
    specialCases.forEach(({ cond, filter }) => {
      if (cond) {
        dataSelect = rows.filter(filter);
      }
    });

    // Update state
    setArrayTable(dataSelect);
    setTimeout(() => setLoading(false), 200);

    // Show appropriate message
    if (dataFilter.length === 0) {
      message.error("ไม่พบข้อมูล");
    } else if (dataSelect.length === 0) {
      message.error("ไม่พบข้อมูลของตัวกรองนี้");
    }
  };

  /**
   * 📥 โหลดข้อมูลจาก API
   * ดึงข้อมูลสัญญาตามประเภทและระยะเวลาที่เลือก
   */
  const loadData = async () => {
    console.log("loadData");
    // Validation
    if (!dataType && searchType !== "resue" && searchType !== "defict") {
      message.error("กรุณาเลือกประเภทสัญญา");
      return;
    }

    if (
      !typeSelect &&
      typeSelect !== 0 &&
      searchType !== "contno" &&
      searchType !== "resue" &&
      searchType !== "defict"
    ) {
      message.error("กรุณาเลือกระยะเวลาประเภทงาน");
      return;
    } else if (
      (searchType === "contno" ||
        searchType === "resue" ||
        searchType === "defict") &&
      !searchContno
    ) {
      message.error("ใส่เลขสัญญา");
      return;
    }

    const useData = searchType === "time" ? typeSelect : 240;

    setLoading(true);
    let endpoint;
    let payload;
    console.log("searchType", searchType);

    if (searchType === "defict") {
      endpoint = `${POST_LOAN_DB2}`; // cal
      payload = {
        CONTNO: `'${searchContno.trim()}'`,
      };
    } else if (searchType === "resue") {
      endpoint = `${POST_LOAD_RESUE_JUDGE}`; // cal
      payload = {
        userId: 1,
        contno: searchContno.trim(""),
      };
    } else {
      endpoint = `${POST_PRE_INVESTIGATE_CHECK}${useData}-v2`; // cal
      payload = {
        DATA_TYPE: dataType,
        date: searchType !== "contno" ? dayjs().format("YYYY-MM-DD") : "",
        flagSearch:
          searchType === "time" ? 1 : searchType === "period" ? typeSelect : 2, //1 หาตามเวลา 2 หาตามเลขสัญญา 8,12 หาตามค้างงวด 8,12 งวด
        CONTNO: searchType !== "contno" ? "" : searchContno.trim(""),
        // Company: userCompany === "3" ? "2" : "1",
      };
    }

    try {
      if (searchType === "defict") {
        // ฟ้องส่วนต่าง -> เช็คก่อนว่ามีสัญญาในระบบแล้วหรือยัง
        const checkData = await axios
          .post(
            POST_CONTNO_DETAIL_SEARCH,
            { CONTNO: searchContno.trim() },
            { headers: HEADERS_EXPORT_DETAIL },
          )
          .then((res) => res.data)
          .catch((err) => {
            if (err?.response?.data) return err.response.data;
            throw err;
          });

        if (checkData?.details !== "ไม่พบข้อมูล") {
          message.warning("มีสัญญาในระบบแล้ว โปรดติดต่อ IT");
          setArrayTable([]);
          setArrData([]);
          return;
        }
      }

      const { status, data } = await axios.post(endpoint, payload, {
        headers: HEADERS_EXPORT_BEN,
      });

      if (status !== 200) {
        throw new Error(`HTTP ${status}`);
      }

      // ไม่มีข้อมูล
      if (
        !data ||
        (Array.isArray(data) && data?.length === 0) ||
        status === 201
      ) {
        message.warning("ไม่มีข้อมูล");
        setArrayTable([]);
        setArrData([]);
        return;
      }
      console.log("data", data);

      if (searchType === "resue") {
        // ฟ้องซ้ำ -> response เป็น object เดียว { canResue, judge, problems, warnings }
        const rows = [
          {
            ...data?.judge,
            canResue: data?.canResue,
            problems: data?.problems ?? [],
            warnings: data?.warnings ?? [],
            key: 1,
          },
        ];
        setTableMode("resue");
        setArrData(rows);
        setArrayTable(rows);
      } else if (searchType === "defict") {
        // ฟ้องส่วนต่าง -> ไม่ต้อง filter ข้อมูล
        const rows = (Array.isArray(data) ? data : [data]).map((item, i) => ({
          ...item,
          key: i + 1,
        }));
        setTableMode("defict");
        setArrData(rows);
        setArrayTable(rows);
      } else {
        // มีข้อมูล -> ส่งต่อไปยัง filterData
        setTableMode("normal");
        filterData(data);
      }
      setAdvanceSearch(true);
      clearSelectedRows();
    } catch (error) {
      message.error(`${error?.response?.data?.error ?? "ติดต่อผู้ดูแลระบบ"}`);
      setArrayTable([]);
      setArrData([]);
    } finally {
      setLoading(false);
    }
  };

  /**
   * 🔍 กรองข้อมูลตาม company และเงื่อนไขอื่นๆ
   * - บริษัท 3: ไม่รวมสาขาใน optionsLocat (ยกเว้น UD)
   * - บริษัทอื่น: เฉพาะสาขาใน optionsLocat
   * - กรองเลขสัญญาที่ขึ้นต้นด้วย 5, 6, 7 ออก
   */
  const filterData = async (value) => {
    if (!Array.isArray(value)) return;

    const newData = value.filter(
      (item) =>
        (item.currentStatus <= 3 ||
          item.currentStatus === 8 ||
          item.currentStatus === 9 ||
          item.currentStatus === 27) &&
        (item.BALANC - item.SMPAY > 30000 || searchType === "contno"),
    );

    // ── กรองที่ไม่ผ่าน filter ─────────────────────────────────────
    const rejectedData = value
      .filter(
        (item) =>
          !(
            (item.currentStatus <= 3 ||
              item.currentStatus === 8 ||
              item.currentStatus === 9 ||
              item.currentStatus === 27) &&
            item.BALANC - item.SMPAY > 30000
          ),
      )
      .map((item) => {
        const statusLabel =
          STATUS_PROCESS.find((s) => s.value === item.currentStatus)?.label ??
          "ไม่ทราบสถานะ";

        // ── เหตุผลที่ไม่ผ่าน ──────────────────────────────────────
        const reasons = [];

        const statusOk =
          item.currentStatus <= 3 ||
          item.currentStatus === 8 ||
          item.currentStatus === 9 ||
          item.currentStatus === 27;

        const balanceOk = item.BALANC - item.SMPAY > 30000;

        if (!statusOk) {
          reasons.push(
            `สถานะไม่ตรงเงื่อนไขนำเข้า (สถานะปัจจุบัน → ${item.currentStatus}: ${statusLabel})`,
          );
        }
        if (!balanceOk) {
          reasons.push(
            `ยอดคงเหลือไม่ถึง 30,000 (${(item.BALANC - item.SMPAY).toLocaleString()} บาท)`,
          );
        }

        return {
          ...item,
          statusLabel,
          rejectReasons: reasons,
        };
      });

    if (rejectedData?.length > 0) {
      console.log("rejectedData", rejectedData);
      message.error(rejectedData?.[0]?.rejectReasons?.[0]);
    }

    let filteredData;

    if (userCompany === "3") {
      // บริษัท 3: ไม่รวมสาขาใน optionsLocat หรือ เลขสัญญา UD
      filteredData = newData.filter((item) => {
        const branch = item.LOCAT;
        if (!branch) return true;

        return (
          !optionsLocat.some((opt) => branch.includes(opt.label)) ||
          item.CONTNO.includes("UD")
        );
      });
    } else {
      // บริษัทอื่น: เฉพาะสาขาใน optionsLocat
      filteredData = newData.filter((item) => {
        const branch = item.LOCAT;
        if (!branch) return false;
        return optionsLocat.some((opt) => branch.includes(opt.label));
      });
    }

    // กรองเลขสัญญาที่ไม่ต้องการ (5, 6, 7)
    // const dataNoUse = filteredData.filter((item) => {
    //   const firstChar = item.CONTNO?.substring(0, 1);
    //   return !["5", "6", "7"].includes(firstChar);
    // });

    // เพิ่ม key สำหรับ table
    let i = 1;
    const newDataUse = filteredData.map((item) => ({
      ...item,
      key: i++,
    }));
    console.log("value", newData);
    console.log("filteredData", filteredData);
    console.log("newDataUse", newDataUse);
    handlefilterData(newDataUse);
    setArrData(newDataUse);
    setLoading(false);
  };

  /**
   * 💾 บันทึกข้อมูลผ่าน API (Generic function)
   * @param {Object} payload - ข้อมูลที่จะส่ง
   * @param {String} apiUse - API endpoint
   * @param {Object} opts - Options (silence, onFinally)
   */
  const insertData = async (payload, apiUse, opts = {}) => {
    console.log("insertData");
    const { silence = false } = opts;
    setLoading(true);
    try {
      if (!apiUse) throw new Error("apiUse is required");

      const res = await axios.post(`${BASE_URL_BEN}${apiUse}`, payload, {
        headers: HEADERS_EXPORT_BEN,
      });

      const ok = res.status >= 200 && res.status < 300;
      if (!ok) {
        if (!silence) message.error(`โหลดไม่สำเร็จ (${res.status})`);
        return null;
      }

      const data = res.data;
      if (!data || (Array.isArray(data) && data.length === 0)) {
        if (!silence) message.warning("ไม่พบข้อมูล");
        return Array.isArray(data) ? data : [];
      }

      if (!silence) message.success("ดำเนินการสำเร็จ");
      return data;
    } catch (err) {
      const status = err?.response?.status;
      console.error("insertData error:", err);
      if (!silence) {
        message.error(
          `เกิดข้อผิดพลาดในการดึงข้อมูล${status ? ` (${status})` : ""}`,
        );
      }
      return null;
    } finally {
      clearSelectedRows();
      setLoading(false);
      loadData();
    }
  };

  /**
   * 🔎 Query ข้อมูลสัญญาจาก LOAN_DB2
   */
  const queryData = async (payload) => {
    console.log("queryData");

    try {
      const res = await axios.post(POST_LOAN_DB2, payload, {
        headers: HEADERS_EXPORT_BEN,
      });

      if (res.status === 200) {
        if (!res.data) {
          message.error("สัญญาไม่ถูกต้อง โปรดตรวจสอบสัญญา");
          return null;
        }

        // กรณี error message เป็น string
        if (typeof res.data === "string") {
          if (res.data.includes("Contract No. Not Found")) {
            message.error("ไม่พบเลขที่สัญญา");
            return null;
          }
          message.error(res.data);
          return null;
        }

        return Array.isArray(res.data) ? res.data : [res.data];
      }

      message.error("ดึงข้อมูลไม่สำเร็จ");
      return null;
    } catch (err) {
      console.error("queryData error:", err);
      message.error("เกิดข้อผิดพลาดในการดึงข้อมูล");
      return null;
    }
  };

  /**
   * 📦 เตรียมข้อมูลสำหรับส่ง API
   * @param {Array} rawData - ข้อมูลที่เลือก
   * @param {Number} btnUse - ประเภทการทำงาน (1=สืบ, 2=บอกเลิก, 3=ทั้งสอง)
   */
  const prepareDataForSubmit = (rawData = [], btnUse) => {
    const contnos = rawData
      .map((x) => String(x?.CONTNO ?? "").trim())
      .filter(Boolean);

    // btnUse = 2: ส่งเป็น array of objects
    if (btnUse === 2) {
      return contnos.map((val) => ({ CONTNO: val, DATA_TYPE: dataType }));
    }

    // btnUse อื่นๆ: ส่งเป็น string แบบ quoted
    const formatted = contnos
      .map((v) => `'${v.replace(/'/g, "''")}'`)
      .join(",");
    return { CONTNO: formatted };
  };

  /**
   * 📤 ส่งข้อมูลไปประมวลผล
   * @param {Number} btnUse - 1=สืบทรัพย์, 2=บอกเลิก, 3=ทั้งสอง
   *
   * Logic:
   * - btnUse = 1: ส่งสืบทรัพย์ (แบ่งเป็น chunks ละ 20 รายการ)
   * - btnUse = 2: ส่งออกบอกเลิก
   * - btnUse = 3: ส่งสืบทรัพย์+บอกเลิก (แบ่งเป็น chunks ละ 20 รายการ)
   */
  const handleDataQuery = async (btnUse) => {
    // เลือก API endpoint ตาม action
    let urlUse;
    if (btnUse === 1) {
      urlUse = POST_PRE_INVESTIGATE;
    } else if (btnUse === 2) {
      urlUse = POST_CANCEL_HAND_PRE;
    } else if (btnUse === 3) {
      urlUse = POST_PRE_INVESTIGATE_CANCEL_HAND;
    }

    const dataUse = prepareDataForSubmit(selectedRows, btnUse);

    let dataSend;

    if (btnUse === 2) {
      // btnUse = 2: ส่งตรงๆ ไม่ต้อง query เพิ่ม
      dataSend = dataUse;
    } else {
      // btnUse = 1 หรือ 3: ต้อง query LOAN_DB2 ก่อน
      const contnoArray = dataUse.CONTNO.split(",").map((c) =>
        c.trim().replace(/'/g, ""),
      );

      // แบ่งเป็น chunks ละ 20 รายการ (เพื่อไม่ให้ query ใหญ่เกินไป)
      const chunkSize = 20;
      const chunks = [];
      for (let i = 0; i < contnoArray.length; i += chunkSize) {
        chunks.push(contnoArray.slice(i, i + chunkSize));
      }

      console.log(`แบ่งเป็น ${chunks.length} รอบ`);

      // Query ทีละ chunk
      dataSend = [];
      for (let i = 0; i < chunks.length; i++) {
        const chunk = chunks[i];
        const contnoString = chunk.map((c) => `'${c}'`).join(",");

        console.log(
          `กำลัง query รอบที่ ${i + 1}/${chunks.length} (${
            chunk.length
          } รายการ)`,
        );

        const result = await queryData({ CONTNO: contnoString });

        if (result && result.length > 0) {
          dataSend.push(...result);
        }
      }

      console.log("Total results:", dataSend.length);
    }

    // ส่งข้อมูลไป API
    if (dataSend.length > 0 || dataSend) {
      insertData(dataSend, urlUse);
    } else {
      message.error("ไม่สารถบันทึกข้อมูลได้ !!");
    }
  };

  // ==================== EVENT HANDLERS ====================
  /**
   * 🔄 เปลี่ยนประเภทระยะเวลา (270/180/120 วัน)
   * และ set default สถานะตามระยะเวลา
   */
  const handleChangeType = (value) => {
    setTypeSelect(value);

    // Set default progress data ตามระยะเวลา
    const setProgress =
      value === "240" ? [1, 2, 3] : value === "180" ? [3, 6] : [6];

    setSelectProgessData(setProgress);
  };

  /**
   * 🔄 เปลี่ยนประเภทสัญญา
   */
  const handleChangeDataType = (value) => {
    setDataType(value);
  };

  /**
   * 🔄 เปลี่ยนช่วงเวลาเพิ่มเติม
   */
  const handleSelect = (value) => {
    setSelectRangeTime(value);
  };

  /**
   * 🔄 เปลี่ยนสถานะที่เลือก
   */
  const handleSelectData = (value) => {
    setSelectProgessData(value);
  };

  /**
   * 🔍 เปลี่ยนคำค้นหา
   */
  const onChangeInputSearch = (data) => {
    setSearchInput(data);
  };

  /**
   * ✅ จัดการ row selection
   */
  const onSelectChange = (selectedRowKeys, selectedRows) => {
    setSelectedRowKeys(selectedRowKeys);
    setSelectedRows(selectedRows);
  };

  // ==================== RENDER HELPERS ====================
  /**
   * 🎨 Render สถานะบอกเลิกสัญญา
   * แสดง Tag ตามสถานะต่างๆ:
   * - รอดำเนินการ (purple)
   * - บอกเลิกใช้ไม่ได้ (red)
   * - ตอบกลับครบแล้ว (green)
   * - ตอบกลับบางส่วน (gold)
   * - ยังไม่ตอบกลับ (blue)
   */
  const renderCancelContract = (record) => {
    // กรณีมี datePre แต่ยังไม่มี dateSend
    if (record.datePre && !record.dateSend) {
      return (
        <Tag
          color="purple"
          style={{ textAlign: "center", padding: "2px 10px" }}
        >
          สถานะ : รอดำเนินการ
          <br />
          {dayjs(record.datePre).add(543, "year").format("DD MMM YY")}
        </Tag>
      );
    }

    const dateRound = dayjs(record.dateCancelContno);
    const dateLastPay = dayjs(record.LPAYD);

    // เช็คว่ารอบบอกเลิกอยู่ก่อนวันจ่ายล่าสุดหรือไม่
    if (dateRound.isValid() && dateLastPay.isValid()) {
      const cancelUselessRound = dateRound.isBefore(dateLastPay);
      if (cancelUselessRound) {
        return (
          <Tag color="red" style={{ textAlign: "center", padding: "2px 10px" }}>
            บอกเลิกใช้ไม่ได้
            <br />
            รอบ: {dateRound.add(543, "year").format("DD MMM YY")}
          </Tag>
        );
      }
    }

    // ยังไม่ออกบอกเลิก
    if (!record.dateCancelContno) {
      return <Tag style={{ textAlign: "center" }}>ยังไม่ออกบอกเลิก</Tag>;
    }

    const cancelStatus = record.statusActiveCancelContno;
    const cancelStatusSome =
      record.countCancelContno > 0 &&
      record.maxCancelContno !== record.countCancelContno;
    console.log("cancelStatus", cancelStatus);
    console.log("cancelStatusSome", cancelStatusSome);

    // แสดงสถานะตามเงื่อนไข
    return (
      <div>
        {cancelStatus ? (
          <Tag
            color="green"
            style={{ textAlign: "center", padding: "2px 10px" }}
          >
            สถานะ : ตอบกลับครบแล้ว
            <br />
            รอบ:{" "}
            {dayjs(record.dateCancelContno)
              .add(543, "year")
              .format("DD MMM YY")}
          </Tag>
        ) : cancelStatusSome ? (
          <Tag
            color="gold"
            style={{ textAlign: "center", padding: "2px 10px" }}
          >
            สถานะ : ตอบกลับบางส่วน
            <br />
            รอบ:{" "}
            {dayjs(record.dateCancelContno)
              .add(543, "year")
              .format("DD MMM YY")}
          </Tag>
        ) : record.countCancelContno === 0 ? (
          <Tag
            color="blue"
            style={{ textAlign: "center", padding: "2px 10px" }}
          >
            สถานะ : ยังไม่ตอบกลับ
            <br />
            รอบ:{" "}
            {dayjs(record.dateCancelContno)
              .add(543, "year")
              .format("DD MMM YY")}
          </Tag>
        ) : null}
      </div>
    );
  };

  const renderStatusProcess = (record) => {
    if (!record) return null;

    const status = STATUS_PROCESS.find(
      (item) => item.value === record.currentStatus,
    );

    return (
      <Tag color="orange" style={{ textAlign: "center", padding: "2px 10px" }}>
        {status?.label ?? "ยังไม่ส่งฟ้อง"}
      </Tag>
    );
  };

  /**
   * 📱 Mobile Card Component สำหรับแสดงผลบนมือถือ
   */
  const MobileRowCard = ({ record, checked, onToggle, renderCancel }) => (
    <Card
      size="small"
      style={{ borderRadius: 12 }}
      styles={{ padding: 12 }}
      onClick={onToggle}
    >
      {/* Header: เลขสัญญา + Checkbox */}
      <div style={{ display: "flex", justifyContent: "space-between", gap: 8 }}>
        <div style={{ fontWeight: 700 }}>{record?.CONTNO}</div>
        <Checkbox checked={checked} onChange={onToggle} />
      </div>

      {/* จ่ายล่าสุด */}
      <div style={{ marginTop: 8, color: "#666" }}>
        จ่ายล่าสุด:{" "}
        <b>
          {record?.GREATEST_DATE
            ? dayjs(record.GREATEST_DATE).add(542, "year").format("D MMM YY")
            : "-"}
        </b>{" "}
        ({record?.GREATEST_DATE === record?.TEMPDATE ? "รับฝาก" : "เข้างวด"})
      </div>

      {/* เกรด + ขาดวัน */}
      <div style={{ marginTop: 6 }}>
        เกรด <b style={{ color: "crimson" }}>{record?.GRDCOD}</b> — ขาด{" "}
        {record?.days} วัน
      </div>

      {/* สถานะสืบทรัพย์ */}
      <div style={{ marginTop: 8 }}>
        <Tag
          color={
            record?.statusActiveInvestigate === 3
              ? "green"
              : record?.statusActiveInvestigate === 4
                ? "red"
                : record?.statusActiveInvestigate === 1
                  ? "purple"
                  : record?.statusActiveInvestigate === 2
                    ? "blue"
                    : "default"
          }
          style={{ borderRadius: 8 }}
        >
          สถานะสืบ:{" "}
          {OPTIONS_STATUS.find(
            (item) => item.value === record.statusActiveInvestigate,
          )?.label || "ยังไม่สืบทรัพย์"}{" "}
          {record?.statusActiveInvestigate > 1 && record?.dateOnlineInvestigate
            ? ` / ${dayjs(record.dateOnlineInvestigate)
                .add(543, "year")
                .format("D MMM YY")}`
            : ""}
        </Tag>
      </div>

      {/* สถานะบอกเลิก */}
      <div style={{ marginTop: 6 }}>{renderCancel(record)}</div>
    </Card>
  );

  // ==================== TABLE CONFIGURATION ====================
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const columns = [
    {
      title: "ลำดับ",
      align: "center",
      dataIndex: "key",
      render: (text, record) => (
        <span style={{ fontWeight: "bold" }}>{record.key}</span>
      ),
    },
    {
      title: "เลขสัญญา",
      align: "center",
      render: (record) => (
        <span style={{ fontSize: 14 }}>
          {record?.CONTNO || record?.LOAN?.CONTNO}
        </span>
      ),
    },
    {
      title: "จ่ายล่าสุด",
      align: "center",
      render: (text, record) => (
        <div>
          <div
            style={{
              fontWeight: "bold",
              color: "#1890ff",
            }}
          >
            {record.GREATEST_DATE === record.TEMPDATE ? "รับฝาก" : "เข้างวด"}
          </div>
          <div style={{ fontSize: 12, color: "#888" }}>
            {dayjs(record.GREATEST_DATE).add(542, "year").format("D MMM YY")}
          </div>
        </div>
      ),
    },
    {
      title: "สถานะ",
      align: "center",
      render: (text, record) => (
        <div>
          <div style={{ color: "red" }}>เกรด {record.GRDCOD}</div>
          <div style={{ fontSize: 12, color: "#888" }}>
            ขาดการติดต่อ {record.days} วัน
          </div>
        </div>
      ),
    },
    {
      title: "สถานะสืบทรัพย์",
      align: "center",
      render: (text, record) => (
        <div>
          {record.statusActiveInvestigate > 0 ? (
            <Tag
              color={
                record.statusActiveInvestigate === 3
                  ? "green"
                  : record.statusActiveInvestigate === 4
                    ? "red"
                    : record.statusActiveInvestigate === 1
                      ? "purple"
                      : record.statusActiveInvestigate === 2
                        ? "blue"
                        : "gray"
              }
              style={{ textAlign: "center", padding: "2px 10px" }}
            >
              {OPTIONS_STATUS.find(
                (item) => item.value === record.statusActiveInvestigate,
              )?.label || "-"}{" "}
              <br />
              {record.statusActiveInvestigate === 1
                ? dayjs(record.dateCeoInvestigate)
                    .add(543, "year")
                    .format("D MMM YY")
                : record.statusActiveInvestigate > 1
                  ? dayjs(record.dateOnlineInvestigate)
                      .add(543, "year")
                      .format("D MMM YY")
                  : null}
            </Tag>
          ) : (
            <Tag>ยังไม่เคยสืบ</Tag>
          )}
        </div>
      ),
    },
    {
      title: "สถานะออกบอกเลิก",
      align: "center",
      render: (text, record) => <>{renderCancelContract(record)}</>,
    },
    {
      title: "สถานะงานปัจุบัน",
      align: "center",
      render: (text, record) => <>{renderStatusProcess(record)}</>,
    },
    {
      title: "รายละเอียด",
      dataIndex: "CONTNO",
      key: "CONTNO",
      align: "center",
      render: (text, record) => (
        <div style={{ lineHeight: 1.6 }}>
          <div>
            ยอดจัด{" "}
            <b>{record?.BALANC ? currencyFormatComma(record?.BALANC) : "-"}</b>{" "}
            บาท
          </div>
          <div>
            ชำระรวม{" "}
            <b>{record?.SMPAY ? currencyFormatComma(record?.SMPAY) : "-"}</b>{" "}
            บาท
          </div>
          <div>
            คงเหลือ{" "}
            <span style={{ color: "#f5222d", fontWeight: "bold" }}>
              {(record?.BALANC - record?.SMPAY) / record?.BALANC
                ? (
                    ((record?.BALANC - record?.SMPAY) / record?.BALANC) *
                    100
                  ).toFixed(0)
                : "-"}
              %
            </span>
          </div>
        </div>
      ),
    },
    {
      title: "การจัดการ",
      align: "center",
      render: (text, record) => (
        <div style={{ lineHeight: 1.6 }}>
          <Tooltip title="กรุณาส่ง สืบทรัพย์หรือส่งออกบอกเลิกก่อน">
            {dataType !== "lsfhp" ? (
              <Button
                type="primary"
                danger={
                  (
                    ((record.BALANC - record.SMPAY) / record.BALANC) *
                    100
                  ).toFixed(0) > 10
                }
                ghost
                icon={<SendOutlined />} // ไอคอน
                size="small" // ขนาดเล็ก
                onClick={() => {
                  console.log(record);
                  setDataRecord(record);
                  setIsModal(true);
                  setStatusModal(tableMode === "defict" ? "defict" : null);
                }}
                loading={loading}
                disabled={
                  // (roleId !== "1" || roleId !== "5") &&
                  // (record.statusActiveInvestigate !== 3 ||
                  //   record.statusActiveInvestigate !== 4) &&
                  // !record.statusActiveCancelContno

                  // ฟ้องส่วนต่าง -> ส่งฟ้องได้เลย
                  tableMode !== "defict" &&
                  ((!record.loanId && !record.currentStatus) ||
                    [1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12].includes(
                      record.currentStatus,
                    ))
                }
              >
                "ส่งฟ้อง"
              </Button>
            ) : (
              <Button
                type="primary"
                danger={
                  (
                    ((record.BALANC - record.SMPAY) / record.BALANC) *
                    100
                  ).toFixed(0) > 10
                }
                ghost
                icon={<SendOutlined />} // ไอคอน
                size="small" // ขนาดเล็ก
                onClick={() => {
                  console.log(record);
                  setDataRecord(record);
                  setIsModal(true);
                  setStatusModal(tableMode === "defict" ? "defict" : null);
                }}
                loading={loading}
                disabled={
                  tableMode !== "defict" &&
                  [1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12].includes(
                    record.currentStatus,
                  )
                }
              >
                "ส่งฟ้อง"
              </Button>
            )}
          </Tooltip>
        </div>
      ),
    },
  ];

  const formatThaiDate = (date) =>
    date ? dayjs(date).add(543, "year").format("D MMM YY") : "-";

  const columnsResue = [
    {
      title: "ลำดับ",
      align: "center",
      dataIndex: "key",
      width: 60,
      render: (text) => <span style={{ fontWeight: "bold" }}>{text}</span>,
    },
    {
      title: "เลขสัญญา",
      align: "center",
      render: (record) => (
        <div style={{ lineHeight: 1.6 }}>
          <div style={{ fontSize: 14 }}>{record.newContno}</div>
        </div>
      ),
    },
    {
      title: "ลูกหนี้",
      align: "center",
      render: (record) => (
        <div style={{ lineHeight: 1.6 }}>
          <div style={{ fontWeight: 500 }}>{record.fullName || "-"}</div>
          <div style={{ fontSize: 12, color: "#888" }}>{record.CUSCOD}</div>
        </div>
      ),
    },
    {
      title: "เลขคดี",
      align: "center",
      render: (record) => (
        <div style={{ lineHeight: 1.6 }}>
          <div>
            คดีดำ <b>{record.blackCaseNumber || "-"}</b>
          </div>
          <div>
            คดีแดง{" "}
            <b style={{ color: "#f5222d" }}>{record.redCaseNumber || "-"}</b>
          </div>
        </div>
      ),
    },
    {
      title: "วันที่",
      align: "center",
      render: (record) => (
        <div style={{ lineHeight: 1.6 }}>
          <div>
            พิพากษา <b>{formatThaiDate(record.judgeDate)}</b>
          </div>
          <div style={{ fontSize: 12, color: "#888" }}>
            วันทำสัญญา {formatThaiDate(record.SDATE)}
          </div>
        </div>
      ),
    },
    {
      title: "ยอดคงเหลือ",
      align: "center",
      render: (record) => (
        <b
          style={{ color: Number(record.balance) > 0 ? "#f5222d" : "#52c41a" }}
        >
          {currencyFormatComma(Number(record.balance) || 0)} บาท
        </b>
      ),
    },
    {
      title: "สืบทรัพย์ / บอกเลิก",
      align: "center",
      render: (record) => (
        <Space direction="vertical" size={4}>
          <Tag
            icon={
              record.hasInvestigation ? (
                <CheckCircleTwoTone />
              ) : (
                <CloseCircleOutlined />
              )
            }
            color={record.hasInvestigation ? "success" : "default"}
          >
            {record.hasInvestigation ? "มีผลสืบแล้ว" : "ยังไม่มีผลสืบ"}
          </Tag>
          <Tag
            icon={
              record.hasCancelContract ? (
                <CheckCircleTwoTone />
              ) : (
                <CloseCircleOutlined />
              )
            }
            color={record.hasCancelContract ? "success" : "default"}
          >
            {record.hasCancelContract ? "บอกเลิกแล้ว" : "ยังไม่บอกเลิก"}
          </Tag>
        </Space>
      ),
    },
    {
      title: "สถานะ",
      align: "center",
      render: (record) => (
        <Tag
          icon={
            record.hasInvestigation ? (
              <CheckCircleTwoTone />
            ) : (
              <CloseCircleOutlined />
            )
          }
          color={record.hasInvestigation ? "success" : "default"}
        >
          {record.canResue ? "ฟ้องได้" : "ฟ้องไม่ได้"}
        </Tag>
      ),
    },
    {
      title: "หมายเหตุ",
      width: 280,
      render: (record) =>
        record.problems?.length || record.warnings?.length ? (
          <div style={{ lineHeight: 1.5, fontSize: 14 }}>
            {record.problems?.map((p, i) => (
              <div key={`p-${i}`} style={{ color: "#f5222d" }}>
                <CloseCircleOutlined /> {p}
              </div>
            ))}
          </div>
        ) : (
          <span style={{ color: "#999" }}>-</span>
        ),
    },
    {
      title: "การจัดการ",
      align: "center",
      render: (record) => {
        const blocked = !record.canResue || record.problems?.length > 0;
        return (
          <Tooltip
            title={blocked ? "สัญญานี้ยังไม่สามารถฟ้องซ้ำได้" : "ส่งฟ้องซ้ำ"}
          >
            <Button
              type="primary"
              ghost
              icon={<SendOutlined />}
              size="small"
              disabled={blocked}
              loading={loading}
              onClick={() => {
                console.log("resue", record);
                setDataRecord(record);
                setIsModalResue(true);
              }}
            >
              ส่งฟ้องซ้ำ
            </Button>
          </Tooltip>
        );
      },
    },
  ];

  // ==================== RENDER ====================
  return (
    <>
      {/* ============================================ */}
      {/* 🎯 แถบค้นหา/ฟิลเตอร์หลัก */}
      {/* ============================================ */}
      <Card style={{ marginBottom: 8 }}>
        <Row gutter={[8, 8]}>
          <Col span={24} style={{ textAlign: "start" }}>
            {isMobile ? (
              <>
                <Space wrap size={5}>
                  <Button
                    icon={<FilterOutlined />}
                    style={{ borderRadius: 8 }}
                    onClick={() => setOpenFilter(true)}
                  >
                    ตัวกรอง
                  </Button>
                  <Button
                    type="primary"
                    icon={<SearchOutlined />}
                    size="middle"
                    style={{ borderRadius: 8 }}
                    onClick={onQueryData}
                  >
                    ค้นหา
                  </Button>
                  <Button
                    icon={<ReloadOutlined />}
                    danger
                    onClick={() => {
                      setSelectRangeTime(null);
                      setDataType(null);
                      setTypeSelect(null);
                      setSelectProgessData([]);
                      clearSelectedRows();
                      setArrayTable([]);
                      setArrData([]);
                    }}
                    size="middle"
                    style={{ borderRadius: 8 }}
                  >
                    ล้าง
                  </Button>
                </Space>

                {/* 📱 Drawer สำหรับมือถือ - ฟิลเตอร์หลัก */}
                <Drawer
                  title="ตัวกรอง"
                  open={openFilter}
                  onClose={() => setOpenFilter(false)}
                  width="100%"
                  style={{ paddingBottom: 24 }}
                >
                  <Space
                    direction="vertical"
                    size={10}
                    style={{ width: "100%" }}
                  >
                    <Select
                      style={{ width: 160 }}
                      placeholder="เลือกสัญญา"
                      onChange={handleChangeDataType}
                      popupMatchSelectWidth={false}
                      options={
                        userCompany !== "3" ? OPTIONS_TYPE : OPTIONS_TYPE_KSM
                      }
                      value={dataType}
                      size="large"
                      disabled={
                        searchType === "resue" || searchType === "defict"
                      }
                    />
                    <Radio.Group
                      onChange={(e) => {
                        setSearchContno(null);
                        setTypeSelect(null);
                        setSearchType(e.target.value);
                      }}
                      value={searchType}
                    >
                      <Space direction="vertical">
                        {userCompany === "3" ? (
                          <Radio value="period">หาตามงวด</Radio>
                        ) : (
                          <Radio value="time">หาตามเวลา</Radio>
                        )}
                        <Radio value="contno">หาตามสัญญา</Radio>
                        <Radio value="resue">ฟ้องสัญญาอาญา</Radio>
                        <Radio value="defict">ฟ้องส่วนต่าง</Radio>
                      </Space>
                    </Radio.Group>
                    {searchType !== "contno" &&
                    searchType !== "resue" &&
                    searchType !== "defict" ? (
                      <Select
                        placeholder="ระยะเวลาขาดการติดต่อ"
                        options={
                          userCompany !== "3"
                            ? OPTION_CONTRACT_PERIOD
                            : OPTION_CONTRACT_PERIOD_KSM
                        }
                        value={typeSelect}
                        onChange={handleChangeType}
                        size="large"
                        style={{ width: "100%" }}
                        popupMatchSelectWidth={false}
                      />
                    ) : (
                      <Input
                        style={{ width: "100%" }}
                        placeholder={
                          searchType !== "resue"
                            ? `ค้นหาเลขสัญญา`
                            : `ค้นหาเลขสัญญาที่ฟ้องมาแล้ว`
                        }
                        value={searchContno}
                        onChange={(e) => setSearchContno(e.target.value)}
                        size="small"
                        allowClear
                        suffix={<span style={{ marginRight: 5 }}>🔍</span>}
                      />
                    )}
                  </Space>
                  <Button
                    type="primary"
                    block
                    style={{ marginTop: 12, borderRadius: 8 }}
                    onClick={() => {
                      setOpenFilter(false);
                      onQueryData();
                    }}
                  >
                    ใช้ตัวกรอง
                  </Button>
                </Drawer>
              </>
            ) : (
              <>
                {/* 💻 Desktop - ฟิลเตอร์หลัก */}

                <Tooltip
                  title={advanceSearch ? "ซ่อนตัวกรอง" : "แสดงตัวกรอง"}
                  arrow={mergedArrow}
                >
                  {!advanceSearch ? (
                    <DownSquareOutlined
                      style={{ fontSize: 20, color: "blue", marginTop: 4 }}
                      onClick={toggle} // antd ส่งค่า checked มาให้
                    />
                  ) : (
                    <UpSquareOutlined
                      style={{ fontSize: 20, color: "blue", marginTop: 4 }}
                      onClick={toggle} // antd ส่งค่า checked มาให้
                    />
                  )}
                </Tooltip>
                <Space direction="horizontal" size={10} wrap>
                  <Select
                    style={{ width: 160, marginBottom: 5 }}
                    placeholder="เลือกสัญญา"
                    onChange={handleChangeDataType}
                    popupMatchSelectWidth={false}
                    options={
                      userCompany !== "3" ? OPTIONS_TYPE : OPTIONS_TYPE_KSM
                    }
                    value={dataType}
                    size="large"
                    disabled={searchType === "resue" || searchType === "defict"}
                  />

                  <Radio.Group
                    onChange={(e) => {
                      setSearchContno(null);
                      setTypeSelect(null);
                      setSearchType(e.target.value);
                    }}
                    value={searchType}
                    optionType="button"
                    buttonStyle="solid"
                    size="large"
                    style={{ marginBottom: 5 }}
                  >
                    {userCompany === "3" ? (
                      <Radio.Button value="period">หาตามงวด</Radio.Button>
                    ) : (
                      <Radio.Button value="time">หาตามเวลา</Radio.Button>
                    )}
                    <Radio.Button value="contno">หาตามสัญญา</Radio.Button>
                    <Radio.Button value="resue">ฟ้องสัญญาอาญา</Radio.Button>
                    <Radio.Button value="defict">ฟ้องส่วนต่าง</Radio.Button>
                  </Radio.Group>

                  {searchType !== "contno" &&
                  searchType !== "resue" &&
                  searchType !== "defict" ? (
                    <Select
                      placeholder="ระยะเวลาขาดการติดต่อ"
                      options={
                        userCompany !== "3"
                          ? OPTION_CONTRACT_PERIOD
                          : OPTION_CONTRACT_PERIOD_KSM
                      }
                      value={typeSelect}
                      onChange={handleChangeType}
                      size="large"
                      style={{ width: "100%" }}
                      popupMatchSelectWidth={false}
                    />
                  ) : (
                    <Input
                      placeholder={
                        searchType !== "resue"
                          ? `ค้นหาเลขสัญญา`
                          : `ค้นหาเลขสัญญาที่ฟ้องมาแล้ว`
                      }
                      value={searchContno}
                      onChange={(e) => setSearchContno(e.target.value)}
                      allowClear
                      suffix={<span style={{ marginRight: 5 }}>🔍</span>}
                      style={{ width: "100%" }}
                      size="small"
                    />
                  )}

                  <Button
                    type="primary"
                    icon={<SearchOutlined />}
                    size="large"
                    style={{
                      borderRadius: 8,
                      boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                      fontWeight: "bold",
                      background: "linear-gradient(135deg, #667eea, blue)",
                      border: "none",
                      marginBottom: 5,
                    }}
                    onClick={onQueryData}
                  >
                    ค้นหา
                  </Button>
                  <Button
                    icon={<ReloadOutlined />}
                    onClick={() => {
                      setSelectRangeTime(null);
                      setDataType(null);
                      setTypeSelect(null);
                      setSelectProgessData([]);
                      clearSelectedRows();
                      setArrayTable([]);
                      setArrData([]);
                    }}
                    color="red"
                    variant="outlined"
                    style={{
                      marginBottom: 5,
                    }}
                  >
                    ล้าง
                  </Button>
                </Space>
              </>
            )}
          </Col>

          {/* ============================================ */}
          {/* 🎯 Action Buttons (ส่งสืบ, ส่งบอกเลิก) */}
          {/* ============================================ */}
          <Col span={24} style={{ textAlign: "start", marginTop: 5 }}>
            <Space
              size={10}
              wrap
              direction={isMobile ? "vertical" : "horizontal"}
              style={{ width: isMobile ? "100%" : "auto" }}
            >
              {/* ปุ่มส่งสืบทรัพย์ + บอกเลิก */}
              {/* <Button
                color="blue"
                variant="filled"
                icon={<PlusOutlined />}
                size={isMobile ? "large" : "small"}
                block={isMobile}
                onClick={() => handleDataQuery(3)}
                disabled={
                  selectedRows.length === 0 ||
                  selectedRows.some(
                    (item) =>
                      item.statusActiveInvestigate === 1 ||
                      item.statusActiveInvestigate === 2 ||
                      item.statusActiveInvestigate === 3 ||
                      (item.statusActiveCancelContno !== null
                        ? !isOver30Days(item?.dateCancelContno)
                        : item.statusActiveCancelContno !== null),
                  )
                }
                loading={loading}
                style={{ borderRadius: 8 }}
              >
                ส่งสืบทรัพย์/ส่งออกบอกเลิก{" "}
                {selectedRowKeys.length > 0 && ` (${selectedRowKeys.length})`}
              </Button> */}

              {/* ปุ่มส่งสืบทรัพย์อย่างเดียว */}
              <Button
                color="green"
                variant="filled"
                icon={<PlusOutlined />}
                size={isMobile ? "large" : "small"}
                block={isMobile}
                onClick={() => handleDataQuery(1)}
                disabled={
                  selectedRows.length === 0 ||
                  selectedRows.some(
                    (item) =>
                      item.statusActiveInvestigate === 1 ||
                      item.statusActiveInvestigate === 2 ||
                      item.statusActiveInvestigate === 3,
                  )
                }
                loading={loading}
                style={{ borderRadius: 8 }}
              >
                ส่งสืบทรัพย์{" "}
                {selectedRowKeys.length > 0 && ` (${selectedRowKeys.length})`}
              </Button>

              {/* ปุ่มส่งบอกเลิกอย่างเดียว */}
              {/* <Button
                color="orange"
                variant="filled"
                icon={<PlusOutlined />}
                size={isMobile ? "large" : "small"}
                block={isMobile}
                onClick={() => handleDataQuery(2)}
                disabled={
                  selectedRowKeys.length === 0 ||
                  selectedRows.some((item) =>
                    item.statusActiveCancelContno !== null
                      ? !isOver30Days(item?.dateCancelContno)
                      : item.statusActiveCancelContno !== null,
                  )
                }
                loading={loading}
                style={{ borderRadius: 8 }}
              >
                ส่งออกบอกเลิก{" "}
                {selectedRowKeys.length > 0 && ` (${selectedRowKeys.length})`}
              </Button> */}
            </Space>
          </Col>
        </Row>
      </Card>

      {/* ============================================ */}
      {/* 🎯 ฟิลเตอร์เสริม + ตาราง/การ์ด */}
      {/* ============================================ */}
      <Card>
        <Spin spinning={loading} size="large" tip=" Loading... ">
          <Row gutter={[8, 8]}>
            {/* ฟิลเตอร์เสริม */}
            <Col span={24} style={{ textAlign: "start" }}>
              {isMobile ? (
                <>
                  <Space wrap size={10}>
                    <Button
                      icon={<FilterOutlined />}
                      style={{ borderRadius: 8 }}
                      onClick={() => setOpenFilter2(true)}
                    >
                      ตัวกรองเพิ่มเติม
                    </Button>
                  </Space>

                  {/* 📱 Drawer สำหรับมือถือ - ฟิลเตอร์เสริม */}
                  <Drawer
                    title="ตัวกรองเพิ่มเติม"
                    open={openFilter2}
                    onClose={() => setOpenFilter2(false)}
                    width="100%"
                  >
                    <Space
                      direction="vertical"
                      size={10}
                      style={{ width: "100%" }}
                    >
                      <Select
                        placeholder="เลือกระยะเวลา"
                        onChange={handleSelect}
                        popupMatchSelectWidth={false}
                        options={OPTIONS_TIME}
                        value={selectRangeTime}
                        size="large"
                        style={{ width: "auto" }}
                      />
                      <Select
                        onChange={handleSelectData}
                        popupMatchSelectWidth={false}
                        options={optionsForLawsuit}
                        value={selectProgressData}
                        size="large"
                        mode="multiple"
                        allowClear
                        placeholder="เลือกตัวกรองข้อมูล"
                        style={{ width: "100%" }}
                      />
                      <Input
                        placeholder="ค้นหาสัญญา"
                        value={searchInput}
                        onChange={(e) => onChangeInputSearch(e.target.value)}
                        size="large"
                        style={{ width: "100%", borderRadius: 8 }}
                        suffix={<span style={{ marginRight: 5 }}>👤</span>}
                      />
                      <Button
                        type="primary"
                        icon={<FilterOutlined />}
                        size="large"
                        style={{ borderRadius: 8 }}
                        onClick={() => {
                          setOpenFilter2(false);
                          handlefilterData();
                        }}
                      >
                        กรองข้อมูล
                      </Button>
                      <Button
                        icon={<ReloadOutlined />}
                        onClick={() => {
                          setSelectRangeTime(null);
                          setSelectProgessData([]);
                          setSearchInput(null);
                          clearSelectedRows();
                          setArrayTable(arrData);
                        }}
                        size="large"
                        color="red"
                        variant="outlined"
                        style={{
                          marginBottom: 5,
                        }}
                      >
                        ล้าง
                      </Button>
                    </Space>
                  </Drawer>
                </>
              ) : (
                <>
                  {advanceSearch ? (
                    /* 💻 Desktop - ฟิลเตอร์เสริม */
                    <Space size={10} wrap>
                      <Select
                        style={{ width: 160, marginBottom: 5 }}
                        placeholder="เลือกระยะเวลา"
                        onChange={handleSelect}
                        popupMatchSelectWidth={false}
                        options={OPTIONS_TIME}
                        value={selectRangeTime}
                        size="large"
                      />
                      <Select
                        style={{
                          width: selectProgressData.length > 0 ? "auto" : 220,
                          marginBottom: 5,
                        }}
                        onChange={handleSelectData}
                        popupMatchSelectWidth={false}
                        options={optionsForLawsuit}
                        value={selectProgressData}
                        size="large"
                        mode="multiple"
                        allowClear
                        placeholder="เลือกตัวกรองข้อมูล"
                      />
                      <Input
                        placeholder="ค้นหาสัญญา"
                        value={searchInput}
                        onChange={(e) => onChangeInputSearch(e.target.value)}
                        style={{
                          width: "100%",
                          borderRadius: 8,
                          marginBottom: 5,
                        }}
                        size="small"
                        suffix={<span style={{ marginRight: 5 }}>👤</span>}
                      />
                      <Button
                        type="default"
                        icon={<FilterOutlined />}
                        size="large"
                        style={{
                          borderRadius: 8,
                          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                          fontWeight: "bold",
                          backgroundColor: "#fff7d6",
                          color: "#333",
                          border: "1px solid #ffe58f",
                          marginBottom: 5,
                        }}
                        onClick={() => handlefilterData()}
                      >
                        กรองข้อมูล
                      </Button>
                      <Button
                        icon={<ReloadOutlined />}
                        onClick={() => {
                          setSelectRangeTime(null);
                          setSelectProgessData([]);
                          setSearchInput(null);
                          clearSelectedRows();
                          setArrayTable(arrData);
                        }}
                        color="red"
                        variant="outlined"
                        style={{
                          marginBottom: 5,
                        }}
                      >
                        ล้าง
                      </Button>
                    </Space>
                  ) : null}
                </>
              )}
            </Col>

            {/* ============================================ */}
            {/* 🎯 แสดงผลข้อมูล (Table/Card) */}
            {/* ============================================ */}
            <Col span={24}>
              {isMobile ? (
                /* 📱 Mobile View - แสดงเป็น Cards */
                <Space direction="vertical" size={8} style={{ width: "100%" }}>
                  {arrayTable?.map((r) => (
                    <MobileRowCard
                      key={r.key}
                      record={r}
                      checked={selectedRowKeys.includes(r.key)}
                      onToggle={() => {
                        const checked = selectedRowKeys.includes(r.key);
                        const nextKeys = checked
                          ? selectedRowKeys.filter((k) => k !== r.key)
                          : [...selectedRowKeys, r.key];
                        const nextRows = checked
                          ? selectedRows.filter((x) => x.key !== r.key)
                          : [...selectedRows, r];
                        setSelectedRowKeys(nextKeys);
                        setSelectedRows(nextRows);
                      }}
                      renderCancel={renderCancelContract}
                    />
                  ))}
                  <div style={{ textAlign: "center", color: "#888" }}>
                    จำนวนสัญญาที่ค้นหาทั้งหมด {arrayTable?.length || 0}
                  </div>
                </Space>
              ) : (
                /* 💻 Desktop View - แสดงเป็น Table */
                <Table
                  style={{ marginTop: 10 }}
                  size="small"
                  columns={tableMode === "resue" ? columnsResue : columns}
                  dataSource={arrayTable}
                  rowSelection={rowSelection}
                  scroll={{ x: 900 }}
                  pagination={{ showSizeChanger: true }}
                  footer={() => (
                    <Flex
                      justify="space-between"
                      align="center"
                      style={{ fontWeight: 500 }}
                    >
                      <span
                        style={{
                          color:
                            selectedRowKeys.length > 0 ? "#1890ff" : "#999",
                        }}
                      >
                        {selectedRowKeys.length > 0
                          ? `✓ เลือกแล้ว ${selectedRowKeys.length} สัญญา`
                          : "ยังไม่ได้เลือกสัญญา"}
                      </span>
                      <span>จำนวนสัญญาทั้งหมด: {arrayTable.length} รายการ</span>
                    </Flex>
                  )}
                />
              )}
            </Col>
          </Row>
        </Spin>
      </Card>
      {isModal ? (
        <SendToLawyers
          open={isModal}
          close={setIsModal}
          dataDefault={dataRecord}
          funcUpdateStatus={onQueryData}
          statusModal={statusModal}
        />
      ) : null}
      {isModalResue ? (
        <SendToLawyersResue
          open={isModalResue}
          close={setIsModalResue}
          dataDefault={dataRecord}
          funcUpdateStatus={onQueryData}
          statusModal={statusModal}
        />
      ) : null}
    </>
  );
};

// Export with HOC
const ChooseContract = MotionHoc(Main);
export default ChooseContract;
